import { message } from 'antd'
import StatementsApi from '../../../../api/Finance/Statements'
import AddStatement from '../../../../components/Finance/Statements/AddStatement/AddStatement'
import useActions from '../../../../elements/Hooks/useActions'
import useModalData, { MODAL_TYPE_EDIT, MODAL_TYPE_NEW } from '../../../../elements/Hooks/useModalData'
import useTitle from '../../../../elements/Hooks/useTitle'
import { get, omit, pick } from 'lodash'
import React from 'react'

function AddStatementCont(props) {
  const StatementApi = new StatementsApi()
  const key = get(props.match, 'params.key')

  const {
    visible,
    modalType,
    object: statement,
    setObject: setStatement,
    submitting,
    removing,
    checkForm,
    setSubmitting,
    remove,
    formRef,
    onShow,
    onCancel,
    fetching,
    fetchObject: fetch,
  } = useModalData(
    StatementApi.create,
    StatementApi.update,
    StatementApi.remove,
    undefined,
    key,
    StatementApi.read,
    undefined,
    () => {
      props.history.replace({
        pathname: `/finance/statements/`,
      })
    }
  )

  async function submit() {
    let newObject = await checkForm()
    newObject.period = {
      start: newObject.period[0],
      end: newObject.period[1],
    }
    setSubmitting(true)
    try {
      await StatementApi.create(newObject)
      fetch()
      message.success('Success')
      props.history.replace({
        pathname: `/finance/statements/${key}/update`,
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  async function update() {
    let updatedObject = await checkForm()
    updatedObject.period = {
      start: updatedObject.period[0],
      end: updatedObject.period[1],
    }

    updatedObject = omit(updatedObject, ['company'])
    setSubmitting(true)
    try {
      await StatementApi.update({
        ...updatedObject,
        ...pick(statement, ['_id', '_key', '_rev']),
      })
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  useTitle(!!statement ? `Create New Statement` : `[${statement.code}] Statement`)
  const type = key ? MODAL_TYPE_EDIT : MODAL_TYPE_NEW
  const isNew = type === MODAL_TYPE_NEW

  const { actions, fetchingActions, fetchActions, submittingOperation, submitOperation, handleActions } = useActions(
    'statement',
    statement,
    setStatement,
    StatementApi.operation
  )

  return (
    <AddStatement
      {...{
        key,
        visible,
        modalType,
        statement,
        setStatement,
        submitting,
        submit,
        removing,
        remove,
        formRef,
        onShow,
        onCancel,
        update,
        fetching,
        fetch,
        type,
        isNew,
        actions,
        fetchingActions,
        fetchActions,
        submittingOperation,
        submitOperation,
        handleActions,
      }}
    />
  )
}

export default AddStatementCont
